import { render } from "./CardEventTime.vue?vue&type=template&id=3b0ff588"
import script from "./CardEventTime.vue?vue&type=script&lang=js"
export * from "./CardEventTime.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__